export default __webpack_public_path__ + "static/media/Step-7.b278dc3c.webm";